import { render, staticRenderFns } from "./MainContainer.vue?vue&type=template&id=d2d27176&scoped=true"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"
import style0 from "./MainContainer.vue?vue&type=style&index=0&id=d2d27176&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d27176",
  null
  
)

export default component.exports